

















import { Component, Prop, Vue } from 'vue-property-decorator';

const NO_ORDER_CHILD_MESSAGE = 'Необходимо добавить обучающегося.';

@Component
export default class ComponetsOrdersComponetsOrderChildren extends Vue {
  @Prop({ type: String, default: '' })
  message: string;

  @Prop({ type: Boolean, default: false })
  error: boolean;

  @Prop({ type: Boolean, default: false })
  addChildError: boolean;

  @Prop({ type: [String] })
  srvErrorMsg: string | null

  noOrderChildMessage: string = NO_ORDER_CHILD_MESSAGE;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/orders/OrderMessage.vue